//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Bristol_info',
}



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/Nurse/Chart_Bristol_info.vue